import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Fleet.Fleet_Minimal}
    mutation UpdateFleet($id: ID!, $title: String!, $enterpriseId: ID!, $vehicleIds: [ID!]!) {
        updateFleet(input: { id: $id, title: $title, enterpriseId: $enterpriseId, vehicleIds: $vehicleIds }) {
            errors
            status
            statusCode
            fleet {
                ...Fleet_Minimal
            }
        }
    }
`
